import { useDispatch, useSelector } from '../../../../store/store';
import { setNotification } from '../../../../store/general/slice';
import MotionWrapper from '../../../../containers/MotionWrapper';
import { useCountDown } from '../../../../hooks/useCountDown';
import { toTime } from '../../../../utils/generalHelpers';
import Button from '../../../../components/Button';
import OTP from '../../../../components/OTP';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    confirmPhoneNumberThunk,
    resendPhoneNumberConfirmationCodeThunk,
} from '../../../../store/signUp/thunks';
import {
    selectFetchStatus,
    selectPhoneNumber,
} from '../../../../store/signUp/selectors';

export default function VerifyPhoneNumber() {
    const dispatch = useDispatch();
    const [otp, setOtp] = useState('');
    const fetchStatus = useSelector(selectFetchStatus);
    const phoneNumber = useSelector(selectPhoneNumber);
    const { counter, restart } = useCountDown(180, 'start');
    const { minutes, seconds } = toTime(counter);

    useEffect(() => {
        if (otp.length === 6) next();
    }, [otp]);

    const next = () => {
        dispatch(confirmPhoneNumberThunk(otp));
    };

    const resendOTPCode = () => {
        if (counter > 0) return;
        dispatch(resendPhoneNumberConfirmationCodeThunk(phoneNumber))
            .then(() => {
                restart();
            })
            .catch(() => {
                dispatch(setNotification(['An error occured, please try again.', 'error']));
            })
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <span className={styles.header}>Enter the sent code to:</span>
            <span className={styles.sentTo}>
                {phoneNumber}
            </span>
            <OTP
                value={otp}
                onChange={setOtp}
                numInputs={6}
                onChangeRegex={/^([0-9]{0,})$/}
            />
            <div className={styles.counter}>
                <span className={styles.counter_time}>
                    {minutes}:{seconds} Remaining
                </span>
                <span
                    data-is-deactive={counter > 0}
                    onClick={resendOTPCode}
                    className={styles.counter_resend}
                >
                    Resend code
                </span>
            </div>
            <Button
                text="Confirm"
                onClick={next}
                loading={fetchStatus === 'Pending'}
                disabled={otp.length !== 6}
                className={styles.next}
            />
        </MotionWrapper>
    );
};
